import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CustomerService} from "../../../core/services/customer.service";
import {INewLessorGroup} from "../../model/interface/new-lessor-group.model.interface";
import {MatDialogRef} from "@angular/material/dialog";
import {tap} from "rxjs/operators";
import {SnackBarService} from "../../../core/services/snack-bar.service";

@Component({
  selector: 'app-add-lessor-group',
  templateUrl: './add-lessor-group.component.html',
  styleUrls: ['./add-lessor-group.component.css']
})
export class AddLessorGroupComponent implements OnInit {
  groupForm: FormGroup;

  constructor(private fb: FormBuilder,
              private snackBarService: SnackBarService,
              private dialogRef: MatDialogRef<AddLessorGroupComponent>,
              private customerService: CustomerService) {
  }

  ngOnInit(): void {
    this.groupForm = this.fb.group({
      name: ['', Validators.required, Validators.minLength(3)]
    })
  }

  create() {
    const value = this.groupForm.value as INewLessorGroup;
    return this.customerService.createGroup(value).pipe(
      tap(group => this.snackBarService.displayText(`Utworzono grupę "${group.name}"`))
    ).subscribe(group => {
      this.dialogRef.close(group.id)
    })
  }

}
